import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";

import CancelledImage from "../../assets/images/cancelled-image.png";
import { api } from "../../services/api";
import { PaymentExpiredPageStyles } from "./styles";

function PaymentExpiredPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("id");

    const [paymentStatusMessage, setPaymentStatusMessage] = useState<
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        string | any
    >();

    useEffect(() => {
        api.get(`/checkout/client/${myParam}`)
            .then(() => {
                setPaymentStatusMessage("Solicitação de pagamento expirado!");
            })
            .catch((error) => {
                const data = error.response?.data;
                const responseBody = data?.response;
                const message = Array.isArray(responseBody)
                    ? String(responseBody[0] ?? "Pagamento indisponível.")
                    : data?.message ?? "Pagamento indisponível.";
                setPaymentStatusMessage(message);
            });
    }, []);

    return (
        <PaymentExpiredPageStyles>
            {paymentStatusMessage ? (
                <div className="messageContainer">
                    <h2>
                        {paymentStatusMessage} Entre em contato com nosso
                        suporte. <PermPhoneMsgIcon />
                    </h2>
                    <img
                        className="paymentImageStatus"
                        src={CancelledImage}
                        alt=""
                    />
                </div>
            ) : (
                <ContentLoader viewBox="0 0 380 70">
                    {/* Only SVG shapes */}
                    <rect x="40" y="5" rx="4" ry="4" width="300" height="8" />
                </ContentLoader>
            )}
        </PaymentExpiredPageStyles>
    );
}

export default PaymentExpiredPage;
